/*
  ============================================================
  BOVEA CART UPDATE BRIDGE

  Sicherheitsnetz fuer fremde Aenderungen am Warenkorb, etwa
  durch Apps oder eine geoeffnete zweite Registerkarte.

  Diese Datei schreibt NIE selbst am Warenkorb und sie biegt
  auch window.fetch nicht mehr um. Sie schaut nur in Ruhe
  nach und meldet eine echte Aenderung weiter.

  Eigene Aktionen des Themes melden sich direkt ueber
  bovea-cart-beauty.js. Deshalb reicht hier ein langsamer
  Takt und es entsteht kein Kreisverkehr aus Nachladen und
  Neuzeichnen.
  ============================================================
*/

(function () {
  "use strict";

  if (window.__boveaCartUpdateBridgeInstalled) {
    return;
  }

  window.__boveaCartUpdateBridgeInstalled = true;

  var POLL_INTERVAL = 6000;

  var refreshTimer = null;
  var lastSignature = "";

  function isGift(item) {
    if (
      window.BoveaGiftEngine &&
      typeof window.BoveaGiftEngine.isGift === "function"
    ) {
      return window.BoveaGiftEngine.isGift(item);
    }

    var properties = (item && item.properties) || {};

    return (
      String(properties._bovea_gift || "") !== "" ||
      String(properties._bovea_free_gift || "") === "true" ||
      String(properties._bovea_threshold_gift || "") === "true"
    );
  }

  /*
    Fingerabdruck des Warenkorbs. Nur wenn der sich aendert,
    wird ueberhaupt etwas gemeldet.
  */
  function signature(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return "leer";
    }

    return cart.items
      .map(function (item) {
        return (
          String(item.variant_id) +
          "x" +
          String(item.quantity) +
          (isGift(item) ? "g" : "")
        );
      })
      .sort()
      .join(",") +
      "|" +
      String(cart.total_price || 0);
  }

  function publish(cart) {
    if (!cart) {
      return;
    }

    var current = signature(cart);

    if (current === lastSignature) {
      return;
    }

    lastSignature = current;

    try {
      window.dispatchEvent(
        new CustomEvent(
          "bovea:cart-updated",
          {
            detail: {
              cart: cart
            }
          }
        )
      );
    } catch (error) {
      /* Aeltere Browser ignorieren das Event. */
    }
  }

  function loadCart() {
    return fetch(
      "/cart.js",
      {
        headers: {
          "Accept": "application/json"
        },
        cache: "no-store"
      }
    )
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Warenkorb nicht erreichbar");
        }

        return response.json();
      })
      .then(function (cart) {
        publish(cart);
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function scheduleRefresh(delay) {
    window.clearTimeout(refreshTimer);

    refreshTimer = window.setTimeout(
      loadCart,
      Number(delay || 200)
    );
  }

  /*
    Meldet sich das Theme selbst, uebernehmen wir dessen
    Stand als bekannt. Dann laeuft der naechste Takt nicht
    unnoetig ins Leere.
  */
  window.addEventListener(
    "bovea:cart-updated",
    function (event) {
      if (event.detail && event.detail.cart) {
        lastSignature = signature(event.detail.cart);
      }
    }
  );

  /* Formulare ohne AJAX, etwa von fremden Apps. */
  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;

      if (
        form &&
        form.action &&
        String(form.action).indexOf("/cart") !== -1
      ) {
        scheduleRefresh(800);
      }
    },
    true
  );

  document.addEventListener(
    "cart:updated",
    function () {
      scheduleRefresh(200);
    }
  );

  window.addEventListener(
    "pageshow",
    function () {
      scheduleRefresh(100);
    }
  );

  window.setInterval(
    loadCart,
    POLL_INTERVAL
  );

  loadCart();
})();
